import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=7053f5fe&scoped=true"
import script from "./TableWidget.vue?vue&type=script&lang=js"
export * from "./TableWidget.vue?vue&type=script&lang=js"
import style0 from "./TableWidget.vue?vue&type=style&index=0&id=7053f5fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7053f5fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7053f5fe')) {
      api.createRecord('7053f5fe', component.options)
    } else {
      api.reload('7053f5fe', component.options)
    }
    module.hot.accept("./TableWidget.vue?vue&type=template&id=7053f5fe&scoped=true", function () {
      api.rerender('7053f5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/TableWidget.vue"
export default component.exports